import { useCallback, useEffect, useState } from "react";
import * as dmsService from "../../services/dmsService";

// Active rows of Dealership masters as dropdown options: { variants: [{ label, value, code, row }], ... }.
// `code` is kept because ids are encrypted afresh in every response (match edit forms by code).
// filters: per key query params, e.g. { colours: { colour_type: "EXTERIOR" } }.
export default function useDmsOptions(keys, reloadKey = 0, filters = {}) {
  const [state, setState] = useState({});
  const wanted = keys.join(",");
  const filterKey = JSON.stringify(filters);

  const load = useCallback(async () => {
    const f = JSON.parse(filterKey);
    const entries = await Promise.all(
      wanted.split(",").filter(Boolean).map(async (key) => {
        const [master, alias] = key.split(":");
        try {
          const res = await dmsService.listMaster(master, { status: "ACTIVE", ...(f[alias || master] || {}) });
          const rows = Array.isArray(res?.data) ? res.data : [];
          return [alias || master, rows.map((r) => ({ label: r.code && r.name ? `${r.code} – ${r.name}` : r.name || r.employee_name || r.code, value: r.id, code: r.code || (r.employee_id ? String(r.employee_id) : null), row: r }))];
        } catch {
          return [alias || master, []];
        }
      })
    );
    setState(Object.fromEntries(entries));
  }, [wanted, filterKey]);

  useEffect(() => {
    load();
  }, [load, reloadKey]);

  return state;
}
